import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';

/**
 * Confirm address for existing users
 */
export const ConfirmAddressStep: Step = {
  id: 'confirmaddress',
  pathname: '/confirmaddress',
  canShow: () => true,
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.ChallengePersonalInfo,
};
